export enum LayoutMode {
  Mobile = 'mobile',
  DesktopWithSky = 'desktop_with_sky',
  DesktopNoSky = 'desktop_no_sky',
}
